/**
 * Color Swatch Picker (Epic C-1 — Fundament, Story C-1.3, UX-C2)
 *
 * Curated kleurenpicker: alleen `PLANNING_TASK_COLORS` (packages/shared,
 * Story C-1.1), geen vrije kleurkiezer (AD-10). Elke swatch toont een
 * zichtbaar naamlabel — nooit-alleen-kleur (a11y-conventie, build_constraints).
 *
 * Toggle-button-groep (`aria-pressed`), bewust GEEN `role="radiogroup"`/
 * `role="radio"`: dat ARIA-patroon impliceert pijltjes-toetsnavigatie
 * tussen opties (WAI-ARIA authoring practices), wat hier niet geïmplementeerd
 * is — elke swatch is gewoon een eigen `<button>` in de normale
 * Tab-volgorde, individueel bedienbaar met Tab/Enter/Spatie. Klik op de
 * al-geselecteerde swatch deselecteert (kleur = optioneel, C-1.1 AC 3/4) —
 * geen aparte "geen kleur"-knop nodig.
 */
import { PLANNING_TASK_COLORS } from '@functieloonhuis/shared';

interface ColorSwatchPickerProps {
  value: string | null;
  onChange: (hex: string | null) => void;
}

export function ColorSwatchPicker({ value, onChange }: ColorSwatchPickerProps) {
  return (
    <div
      data-testid="color-swatch-picker"
      role="group"
      aria-label="Kleur"
      className="grid grid-cols-2 gap-2 sm:grid-cols-3"
    >
      {PLANNING_TASK_COLORS.map((color) => {
        const selected = value === color.hex;
        return (
          <button
            key={color.hex}
            type="button"
            aria-pressed={selected}
            data-testid={`color-swatch-${color.hex}`}
            onClick={() => onChange(selected ? null : color.hex)}
            className={`flex items-center gap-2 rounded-md border px-2 py-1.5 text-left text-sm ${
              selected ? 'border-[#2F5A7A] bg-[#E9EEF2]' : 'border-[#E2E8F0] hover:bg-gray-50'
            }`}
          >
            <span
              aria-hidden="true"
              className="h-4 w-4 flex-shrink-0 rounded-full"
              style={{ backgroundColor: color.hex }}
            />
            <span className="text-[#1E293B]">{color.label}</span>
          </button>
        );
      })}
    </div>
  );
}
